<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-content>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="12" v-if="dataSearhcReadyTable">
            <v-card elevation="7">
                <v-card-text>
                  <v-data-table
                    :headers="columnsUse"
                    :items="datareport"
                    :items-per-page="100"
                    dense
                  >
                  </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-content>
  </div>
</template>
<style scoped>
td {
  width: 100%;
}
</style>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
export default {
  components: {
  },
  data () {
    return {
      columnsService: [
        { text: 'คะแนน', value: 'coin' },
        { text: 'สาขา', value: 'Dlr_Code' },
        { text: 'ประเภท Job', value: 'jOB_income' },
        { text: 'JOB_Type', value: 'JOB_Type' },
        // { text: 'DocHead', value: 'DocHead' },
        { text: 'Frame_no', value: 'Frame_no' },
        { text: 'reg_no', value: 'reg_no' },
        { text: 'job_num', value: 'job_num' },
        { text: 'job_date', value: 'job_date' },
        { text: 'Total_AMT', value: 'Total_AMT' }
      ],
      datareport: [],
      dataExchange: [],
      dataBranch: [],
      dataReady: true,
      dataSearhcReadyTable: false,
      checksubmit: true,
      datareportHistory: [],
      dataHistory: false,
      chkbutton: '',
      dateTime: '',
      session: this.$session.getAll(),
      valid: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.columnsUse = this.columns
    await this.getExchange()
    await this.getDataBranch()
    await this.onSearch()
  },
  methods: {
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/" + "get?shopId=" + this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataBranch = response.data
          console.log(this.dataBranch)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getExchange () {
      this.dataExchange = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/productExchangeRate/get?shopId=" + this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataExchange = response.data
          console.log(this.dataExchange)
        })
    },
    onSearch () {
      this.datareport = []
      this.dataSearhcReady = false
      this.dataSearhcReadyTable = false
      let url = ''
      this.columnsUse = this.columnsService
      console.log(this.data)
      var date = new Date()
      date.setDate(date.getDate() - 2)
      //   console.log('date', date.toISOString().substr(0, 10))
      url = 'https://api.betaskthai.com/vgroupl_api/Bereward.php?type=service&vo_date=' + date.toISOString().substr(0, 10) + '&vo_date2=&jOB_income='
      axios
        .get(
          url
        )
        .then(async (response) => {
          // console.log(response)
          let rs = response.data
          var dataService = []
          var pushData = []
          await axios
            .get(
              'https://api.betaskthai.com/vgroupl_api/Bereward.php?type=serviceJOB_Type&vo_date=' + date.toISOString().substr(0, 10) + '&vo_date2=&jOB_income='
            )
            .then(async (response) => {
              // console.log(this.session.data.userName) JOB_Type
              dataService = response.data
            })
          for (var x = 0; x < rs.length; x++) {
            var e = rs[x]
            var dataCheck = dataService.filter(await function (el) {
              return el.job_num === e.job_num
            })
            // console.log(dataCheck)
            if (dataCheck.length > 0) {
              e.JOB_Type = dataCheck[0].JOB_Type
            } else {
              e.JOB_Type = ''
            }
            if (e.jOB_income === 'GR') {
              if (e.Total_AMT > 5000) {
                e.coin = 2000
              } else {
                e.coin = 0
              }
            }
            if (e.jOB_income === 'BP') {
              if (e.Total_AMT >= 6000) {
                e.coin = 3000
              } else {
                if (e.JOB_Type.includes('Gr') || e.JOB_Type.includes('GR')) {
                  if (e.Total_AMT >= 5000) {
                    e.coin = 2000
                  } else {
                    if (e.JOB_Type.includes('Pm') || e.JOB_Type.includes('PM')) {
                      if (e.Total_AMT >= 1000) {
                        e.coin = 1000
                      } else {
                        e.coin = 0
                      }
                    } else {
                      if (e.JOB_Type === 'BP') {
                        e.coin = 0
                      }
                    }
                  }
                } else {
                  if (e.JOB_Type.includes('Pm') || e.JOB_Type.includes('PM')) {
                    if (e.Total_AMT >= 1000) {
                      e.coin = 1000
                    } else {
                      e.coin = 0
                    }
                  } else {
                    if (e.JOB_Type === 'BP') {
                      e.coin = 0
                    }
                  }
                }
              }
            }
            if (e.jOB_income === 'PM') {
              if (e.Total_AMT >= 1000) {
                if (e.JOB_Type.includes('Gr') || e.JOB_Type.includes('GR')) {
                  if (e.Total_AMT >= 5000) {
                    e.coin = 2000
                  } else {
                    e.coin = 1000
                  }
                } else {
                  e.coin = 1000
                }
              } else {
                e.coin = 0
              }
            }
            if (e.jOB_income === 'OTH') {
              e.coin = 0
            }
            if (e.jOB_income === 'AM') {
              e.coin = 0
            }
            let branchName = ''
            if (e.Dlr_Code === '0112') {
              branchName = 'สาขาแจ้งวัฒนะ'
            }
            if (e.Dlr_Code === '0113') {
              branchName = 'สาขาหนองแขม'
            }
            if (e.Dlr_Code === '0115') {
              branchName = 'สาขาบางกอกน้อย'
            }
            if (e.Dlr_Code === '0116') {
              branchName = 'สาขาปากเกร็ด - เมืองทอง'
            }
            if (e.Dlr_Code === '333') {
              branchName = 'สำนักงานใหญ่'
            }
            if (e.coin > 0) {
              var masBranchID = 0
              var productExchangeRateId = 0
              var dataCheckBranch = this.dataBranch.filter(await function (el) {
                return el.masBranchName === branchName
              })
              // console.log('dataCheckBranch', dataCheckBranch[0].masBranchID)
              var dataCheckExchang = this.dataExchange.filter(await function (el) {
                return el.name === e.jOB_income
              })
              // console.log('dataCheckExchang', dataCheckExchang[0].productExchangeRateId)
              this.datareport.push(e)
              if (dataCheckBranch.length > 0) {
                masBranchID = dataCheckBranch[0].masBranchID
              }
              if (dataCheckExchang.length > 0) {
                productExchangeRateId = dataCheckExchang[0].productExchangeRateId
              }
              let dt =
                "('" +
                e.job_date +
                "','" +
                e.job_num +
                "','" +
                e.jOB_income +
                "','" +
                branchName +
                "'," +
                masBranchID +
                ',' +
                productExchangeRateId +
                ",'" +
                e.coin +
                "','" +
                e.Total_AMT +
                "','" +
                e.Frame_no.trim() +
                "','" +
                'wait' +
                "','" +
                'N' +
                "','" +
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                "','" +
                'system' +
                "','" +
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                "','" +
                'system' +
                "')"
              pushData.push(dt)
            }
          }
          // this.datareport = rs
          var usedata = pushData.map(function (pushBookingNums) {
            return decodeURIComponent(pushBookingNums)
          })
          console.log(usedata)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/givePoints/addMulti",
              usedata
            )
            .then(async response => {})
          this.dataSearhcReady = true
          this.dataSearhcReadyTable = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          console.log(error)
          this.errored = true
          this.dataSearhcReady = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/GivePoints.vue